import { proxy } from "@/util/proxy.mjs";

const profileRefs = proxy({
  setupPlaceholder: (container: Document): void => void container,
  SidebarAd: null,
});

export default profileRefs;
